import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
const PURCHASES = [{
  name: 'María',
  city: 'Buenos Aires'
}, {
  name: 'Carlos',
  city: 'Córdoba'
}, {
  name: 'Laura',
  city: 'Rosario'
}, {
  name: 'Diego',
  city: 'Mendoza'
}, {
  name: 'Valentina',
  city: 'Tucumán'
}, {
  name: 'Sofía',
  city: 'Mar del Plata'
}, {
  name: 'Martín',
  city: 'La Plata'
}, {
  name: 'Camila',
  city: 'Salta'
}];
export function SocialProofPopup() {
  const [index, setIndex] = useState(0);
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    // Initial delay
    const initialTimeout = setTimeout(() => {
      setIsVisible(true);
    }, 3000);
    return () => clearTimeout(initialTimeout);
  }, []);
  useEffect(() => {
    if (!isVisible) return;
    const interval = setInterval(() => {
      setIsVisible(false);
      setTimeout(() => {
        setIndex(prev => (prev + 1) % PURCHASES.length);
        setIsVisible(true);
      }, 2000); // Wait 2s before showing next
    }, 8000); // Show for 8s
    return () => clearInterval(interval);
  }, [isVisible]);
  const current = PURCHASES[index];
  return <AnimatePresence data-id="element-247">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      x: -20
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 50
    }} className="fixed bottom-4 left-4 bg-white rounded-lg shadow-2xl p-4 max-w-xs z-40 border-l-4 border-green-500 flex items-center gap-3" data-id="element-248">
          <div className="bg-green-100 p-2 rounded-full" data-id="element-249">
            <CheckCircle2 className="w-6 h-6 text-green-600" data-id="element-250" />
          </div>
          <div data-id="element-251">
            <p className="text-sm font-bold text-gray-800" data-id="element-252">
              {current.name} de {current.city}
            </p>
            <p className="text-xs text-gray-500" data-id="element-253">acaba de comprar este pack</p>
            <p className="text-xs text-green-600 font-semibold mt-1" data-id="element-254">
              Hace unos instantes
            </p>
          </div>
        </motion.div>}
    </AnimatePresence>;
}